/* eslint-disable */
import { FaqEntryInternationalizationContentUpdateDto } from '../dto/faq-entry-internationalization-content-update-dto';
import { FaqEntryStatus } from '../dto/faq-entry-status';

export interface FaqEntryUpdateDto {
  id: number;
  status: FaqEntryStatus;
  categoryIds: number[];
  publishedDate: Date;
  contentPerLanguage: FaqEntryInternationalizationContentUpdateDto[];
}

export const fixFaqEntryUpdateDtoFromJson = (dto?: FaqEntryUpdateDto | null): void => {
  if (!dto) {
    return;
  }
  dto.publishedDate = dto.publishedDate && new Date(dto.publishedDate);
};

export const fixFaqEntryUpdateDtoToJson = (dto?: FaqEntryUpdateDto | null): void => {
  if (!dto) {
    return;
  }
};
